<div id="login-cont">
<div class="login-wrapper"></div>
<div class="login-label">
	<div class="login-title">Login</div>
</div>
<div class="row">
	<div class="col-md-4"></div>
	<div class="col-md-4">
		<form class="login-form" [formGroup]="loginForm" (ngSubmit)="login()">
			<div class="welcome-text">Welcome to <b>Digital Vault</b></div>
			<div class="display-block margin-bottom-10 width-100per" id="username-text"><b>Username</b></div>
			<input formControlName="username" id="username" class="display-block margin-bottom-10 width-100per" type="text" maxlength="15" pInputText required>
			<!-- <select id="username" formControlName="username" class="form-control">
				<option value=''>Select Username</option>
				<option value='ghssuser'>ghssuser</option>
				<option value='opsuser1'>opsuser1</option>
				<option value='opsuser2'>opsuser2</option>
				<option value='GbIvsAstMgtUser'>GbIvsAstMgtUser</option>
				<option value='HsbcAstMgtUser'>HsbcAstMgtUser</option>
				<option value='kpmguser'>kpmguser</option>
				<option value='auditoruser'>auditoruser</option>
				<option value='hkRegulatorUser'>hkRegulatorUser</option>
				<option value='adminUser'>adminUser</option>
			</select> -->
			<!-- <div class="form-error" *ngIf="loginForm.controls['username'].touched && !loginForm.controls['username'].valid">Please Enter Username</div> -->
			<label class="display-block margin-bottom-10 width-100per" id="password-text"><b>Password</b></label>
			<input id="password" formControlName="password" class="display-block width-100per" [type]="passwordType" maxlength="15" pInputText required>
			<!-- <div class="input-password margin-bottom-10">
				<input id="password" formControlName="password" class="display-block width-100per" [type]="passwordType" pInputText required>
				<span class="password-change-icon">
					<span *ngIf="!showPassword" class="glyphicon glyphicon-eye-open" (click)="passwordType = 'text';showPassword = true" style="cursor:pointer"></span>
					<span *ngIf="showPassword" class="glyphicon glyphicon-eye-close" (click)="passwordType = 'password';showPassword = false" style="cursor:pointer"></span>
				</span>
			</div> -->
			<!-- <div class="form-error" *ngIf="loginForm.controls['password'].touched && !loginForm.controls['password'].valid">Please Enter Password</div> -->
			<button pButton id="login-button" type="submit" label="Login" [disabled]="!loginForm.valid"></button>
			<div class="form-error" *ngIf="incorrectUserPas" style="margin-bottom: 0px">Please enter valid Username/Password.</div>
			<div class="form-error" *ngIf="cordaError" style="margin-bottom: 0px">{{cordaError}}</div>
			<div class="form-error" *ngIf="apiNotFound" style="margin-bottom: 0px">Unable to connect to server. Please contact to Administrator.</div>
		</form>
	</div>
	<div class="col-md-4"></div>
</div>
</div>

<!-- <form action="http://A356T0L63DHHFCL.in.hsbc:8080/samltoken" method="post" id="digithubForm">
	<input name=".pid" type="hidden" value="509714">
	<input name="appId" style="display:none" type="hidden" value="HSSDV" id="appId">
	<input name="token" style="display:none" type="hidden" value="ABCD" id="SAMLResponse">
</form>
<button>
	<a href="javascript:document.getElementById('digithubForm').submit();" class="actionProcessed"><span class="innerAction">Go</span></a>
</button> -->
